import { ActivityEntityName, SaleOrderStatus } from '../../../../entities';
import { getSchema, MergeField, MergeSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.SaleOrder,
    displayName: "Sale Order",
})
export class SaleOrderMergeData {
    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField({
        displayName: "Sale Order Number"
    })
    saleOrderNumber: string;

    @MergeField({
        displayName: "Customer Reference"
    })
    customerRef: string;

    @MergeField()
    date: string;

    @MergeField()
    expiryDate: string;

    @MergeField()
    totalEx?: string;

    @MergeField()
    totalInc?: string;

    @MergeField()
    totalTax?: string;

    @MergeField()
    status: SaleOrderStatus;

    @MergeField()
    createdBy?: string;

    @MergeField()
    createdDate?: string;

    @MergeField()
    jobNumber: string;

    @MergeField()
    workOrderNumber: string;
}

export const SaleOrderMergeSchema = getSchema(SaleOrderMergeData);